





































































































declare const $: any;
import Vue from 'vue';
import { Campaign, SalesforceEmployerLocation } from '@/types';
import { Utils } from '@/Utils';
import axios from 'axios';

interface Data {
    campaign: Campaign;
    form: CampaignAdvancedSettingsForm;
}

interface CampaignAdvancedSettingsForm {
    id: number;
    salesforceEnabled: boolean;
    salesforceEmployerLocations: SalesforceEmployerLocation[];
    allowOther: boolean;
}

export default Vue.extend({
    data: function(): Data {
        return {
            campaign: undefined,
            form: undefined,
        };
    },
    created: function() {
        this.fetchSettings();
    },
    props: {
        campaignPath: {
            type: String,
            required: true,
        },
    },
    methods: {
        async fetchSettings()  {
            await axios.get(`${process.env.VUE_APP_API_URI}/api/admin/weblinks/${this.$props.campaignPath}`)
            .then(res => {
                if (res.status !== 200) {
                    Utils.toastError('Unable to fetch campaign!');
                } else {
                    var campaign: Campaign = res.data;
                    this.setSettings(campaign);
                }
            });
        },
        setSettings(campaign: Campaign) {
            this.campaign = campaign;
            this.form = {
                id: this.campaign.id,
                salesforceEnabled: this.campaign.salesforceEnabled,
                salesforceEmployerLocations: this.campaign.salesforceEmployerLocations,
                allowOther: this.campaign.data.allowOther
            } as CampaignAdvancedSettingsForm;  

            if (!this.form.salesforceEmployerLocations) {
                this.form.salesforceEmployerLocations = [];
            } else {
                // We need to generate some ids for vue to use to track component rendering.
                for(const sfEmp of this.form.salesforceEmployerLocations) {
                    sfEmp.id = this.getNewLocationInternalId();
                }
            }
        },
        async saveSettings()  {
            await axios.post(
                `${process.env.VUE_APP_API_URI}/api/admin/weblinks/${this.campaign.id}/updateadvsettings`,
                this.form
            )
            .then(res => {
                if (res.status !== 200){
                    Utils.toastError('Failed to save settings!')
                } else {
                    Utils.toastSuccess('Successfully saved campaign advanced settings!')
                }
            })
        },
        search(input) {
            return new Promise((resolve) => {
                if (input.length < 3) {
                    return resolve([])
                }

                axios.get(`${process.env.VUE_APP_API_URI}/api/admin/salesforcelocationsearch?query=${encodeURI(input)}`)
                .then(res => {
                    if (res.status !== 200) {
                        Utils.toastError('Unable to fetch Salesforce employer locations!');
                        resolve([]);
                    } else {
                        resolve(res.data);
                    }
                });
            })
        },
        deleteEmployer(i) {
            this.form.salesforceEmployerLocations.splice(i, 1);
        },
        getResultValue(result) {
            return result.name;
        },
        onSubmit(result, i) {
            // retain the id we generated when we created the placeholder object.
            result.id = this.form.salesforceEmployerLocations[i].id;

            this.form.salesforceEmployerLocations[i] = result;
        },
        locationInternalIdExists(id) {
            for (const location of this.form.salesforceEmployerLocations) {
                if (location.id == id) return true;
            }
            return false;
        },
        getNewLocationInternalId(){
            var id: number;
            do {
                id = Math.random();
            } while (this.locationInternalIdExists(id));
            return id;
        },
        addCreateEmployer() {
            this.form.salesforceEmployerLocations.push({
                name: '',
                salesforceId: null,
                id: this.getNewLocationInternalId() // Find an id to use (needed internally for the vue list rendering to work correctly)
            });
        },
    },
});
